import { Injectable } from '@angular/core';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';

import {TimerObservable} from "rxjs/observable/TimerObservable";
import { Subscription } from 'rxjs/Subscription';
import { environment } from '../../environments/environment';
@Injectable()
export class GlobalService {

  BASE_URL: string = environment.apiBaseURL;
  PORTAL_INFO_URL: string = this.BASE_URL + "/portalinfo";
  AUTH_URL: string = this.BASE_URL + "/auth";
  RESOURCE_LIST_URL: string = this.BASE_URL + "/getresources";
  PLAYER_LIST_URL: string = this.BASE_URL + "/getplayers";
  SUBMIT_URL: string = this.BASE_URL + "/savecontent";
  

  //private headerSubject = new Subject<Headers>();
  //private header: Headers;

  private loadingSubject = new Subject<Boolean>();

  private inactiveTime: number;
  private inactiveTimeSubscription: Subscription;

  private warningTime: number;
  private warningTimeSubscription: Subscription;
  
  private sessionActiveSubject = new Subject<Boolean>();

  private warningActiveSubject = new Subject<Boolean>();

  constructor() { 
    this.sessionActiveSubject.next(true);
    this.warningActiveSubject.next(false);
  }

  /*getHeaders(): Headers{
    let headers = new Headers({
      'Content-Type': 'application/json', 
      authorization : localStorage.getItem("token"),
      withCredentials : true
    });
    return headers;
  }*/

  /*getHeader(): Observable<Headers>{
    return this.headerSubject.asObservable();
  }*/
  
  /*setHeader(token: string): void{
    this.header = new Headers({
      'Content-Type': 'application/json', 
      authorization : token,
      withCredentials : true
    });
    localStorage.setItem("token", token);
    this.headerSubject.next(this.header);
  }*/

  setInactiveTimer(timeStr: string): void{
    this.inactiveTime = +timeStr;
    let timer = TimerObservable.create(this.inactiveTime);
    var self = this;
    this.inactiveTimeSubscription.unsubscribe();
    this.warningTimeSubscription.unsubscribe();
    this.inactiveTimeSubscription = timer.subscribe(() => {
      if(self.warningTime){
        let warningTimer = TimerObservable.create(self.warningTime);
        var anotherSelf = this;
        self.warningTimeSubscription = warningTimer.subscribe(() => {
          self.sessionActiveSubject.next(false);
        });
      }
    });
  }

  setWarningTimer(timeStr: string): void{
    this.warningTime = +timeStr;
    this.warningTimeSubscription.unsubscribe();
  }

  resetInactiveTimer(): void{
    let timer = TimerObservable.create(this.inactiveTime);
    var self = this;
    this.inactiveTimeSubscription.unsubscribe();
    this.warningTimeSubscription.unsubscribe();
    this.inactiveTimeSubscription = timer.subscribe(() => {
      if(self.warningTime){
        let warningTimer = TimerObservable.create(self.warningTime);
        var anotherSelf = this;
        self.warningActiveSubject.next(true);
        self.warningTimeSubscription = warningTimer.subscribe(() => {
          self.sessionActiveSubject.next(false);
        });
      }
    });
  }

  resetWarningTimer(): void{
    this.warningTimeSubscription.unsubscribe();
    this.warningActiveSubject.next(false);
  }

  setLoading(flag: Boolean): void{
    this.loadingSubject.next(flag);
  }

  subscribeToLoading(): Observable<Boolean>{
    return this.loadingSubject.asObservable();
  }

  subscribeToInactive(): Observable<Boolean>{
    return this.sessionActiveSubject.asObservable();
  }

  subscribeToWarning(): Observable<Boolean>{
    return this.warningActiveSubject.asObservable();
  }

  ngOnDestroy() {
    
  }
}



// WEBPACK FOOTER //
// ./src/app/services/global.service.ts